module.exports = __webpack_public_path__ + "static/media/Interview.b0fdadac.svg";